export default __webpack_public_path__ + "static/1197-b35684710edc41eb6f839c61276f362d.gif";